<span class="with-stripe" *ngFor="let word of words">
  {{word}}
</span>